import styled from 'styled-components';
import { Menu } from 'ui/menu';
import { PageHeader } from 'ui/pageHeader';
import { spacing } from 'ui/theme';

export const StyledPageHeader = styled(PageHeader)`
  margin: ${spacing.plusThreeQuarter} 0 ${spacing.plusHalf} 0;
`;

export const StyledMenu = styled(Menu)`
  [data-style-id="filter-menu"] {
    width: ${spacing.x16};
  }

  [data-style-id="filter-menu"] [data-truncate="true"] {
    max-width: ${spacing.x12} !important;
  }
`;
